export default __webpack_public_path__ + "static/media/Intelligence_HTB.d15f3b25.md";